import classNames from 'classnames';
import textClassSwitcher from '../../utils/textClassSwitcher';
import { tagsName } from '../Tags.css';
import type { TTagsAttributes } from '../Tags.types';

interface Props {
  name: string;
  className?: string;
  /**
   * @deprecated we should pass in the attributes from the serializer.
   * if we're using it for styling, use CSS variables on the root level
   * */
  attributes: TTagsAttributes;
}

const Name = ({ name, className = '', attributes }: Props) => {
  return (
    <span className={classNames(tagsName, textClassSwitcher(className, attributes?.nameFontSize || 'text-lg'))}>
      {name}
    </span>
  );
};
export default Name;
